/**
 * Shipment-status reference data (T12, frontend-only). Single source for the
 * Sales package selects and the read-only shipment chip, mirroring the backend
 * `ShipmentStatus`. Pages import these instead of inlining status arrays.
 *
 * `SHIPMENT_STATUSES` entries are `[key, label]` (select option order;
 * `not_shipped` is the record-time default). `SHIPMENT_STATUS_LABEL` maps a
 * status key to its display name. `SHIPMENT_STATUS_CHIP` maps a status to its
 * chip tone, reusing the DESIGN.md status tokens (`bg-<token>/13 text-<token>`)
 * — `not_shipped` is the muted default and renders no chip in the row.
 */

/** Ordered shipment-status options. `not_shipped` is the default at record time. */
const SHIPMENT_STATUSES = [
  ['not_shipped', 'Not shipped'],
  ['shipped', 'Shipped'],
  ['delivered', 'Delivered'],
  ['returned', 'Returned'],
];

/** Status key → display name. */
const SHIPMENT_STATUS_LABEL = Object.fromEntries(SHIPMENT_STATUSES.map(([key, label]) => [key, label]));

/** Status key → chip tone classes (DESIGN.md status tokens). */
const SHIPMENT_STATUS_CHIP = {
  not_shipped: 'bg-surface-2 text-ink-subtle',
  shipped: 'bg-info/13 text-info',
  delivered: 'bg-success/13 text-success',
  returned: 'bg-warning/13 text-warning',
};

export {
  SHIPMENT_STATUS_CHIP,
  SHIPMENT_STATUS_LABEL,
  SHIPMENT_STATUSES,
};
